import React from "react";
import { formatZAR } from "@/lib/api";
import { MENU } from "@/constants/testIds";
import { Plus } from "lucide-react";

export default function ProductCard({ item, onSelect }) {
    const hasMods = (item.modifiers || []).length > 0;
    const testSuffix = item.slug;
    return (
        <div
            data-testid={`${MENU.itemPrefix}${testSuffix}`}
            className="card-panel group flex flex-col"
        >
            <div className="aspect-[4/3] bg-brand-ink overflow-hidden relative">
                {item.image_url ? (
                    <img
                        src={item.image_url}
                        alt={item.name}
                        className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
                        loading="lazy"
                    />
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-brand-mute text-sm">
                        Image coming soon
                    </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent pointer-events-none" />
                {item.sold_out && (
                    <span data-testid={`sold-out-badge-${testSuffix}`} className="absolute top-3 right-3 text-[10px] tracking-[0.2em] uppercase bg-brand-ink/90 text-brand-cream border border-brand-line px-2 py-1">
                        Sold out today
                    </span>
                )}
                {item.featured && (
                    <span className="absolute top-3 left-3 text-[10px] tracking-[0.2em] uppercase bg-brand-gold text-brand-ink px-2 py-1">
                        Signature
                    </span>
                )}
            </div>
            <div className="p-5 flex flex-col flex-1">
                <div className="flex items-start justify-between gap-3">
                    <h3 className="font-display text-lg text-brand-cream leading-tight">{item.name}</h3>
                    <span className="text-brand-gold font-medium whitespace-nowrap">{formatZAR(item.price)}</span>
                </div>
                {item.description && (
                    <p className="mt-2 text-sm text-brand-mute leading-relaxed line-clamp-3">{item.description}</p>
                )}
                <button
                    data-testid={`${MENU.addBtnPrefix}${testSuffix}`}
                    onClick={() => onSelect(item)}
                    disabled={item.sold_out}
                    className="mt-4 disabled:opacity-40 disabled:pointer-events-none inline-flex items-center justify-center gap-2 bg-brand-ink border border-brand-line hover:border-brand-olive hover:text-brand-gold text-brand-cream/90 py-2.5 text-sm transition-colors rounded-sm"
                >
                    <Plus size={14} />
                    {item.sold_out ? "Sold out today" : hasMods ? "Customize & Add" : "Add to cart"}
                </button>
            </div>
        </div>
    );
}
